module.exports = __webpack_public_path__ + "img/block-768.9830aac3.jpg";